import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  province: undefined,
  city: undefined,
  country:undefined
};

const settingSlice = createSlice({
  name: 'setting',
  initialState,
  reducers: {
    setting(state, action) {
      console.log(action.payload)
      if (action.payload.province !== undefined) {
        state.province = action.payload.province;
      }
      if (action.payload.city !== undefined) {
        state.city = action.payload.city;
      }
      if (action.payload.country !== undefined) {
        state.country = action.payload.country;
      }
    },
  },
});

export default settingSlice;
export const { setting } = settingSlice.actions;
